// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
Navbar styles
========================================================================== */
.brand-logo {
  display: flex;
  justify-content: center;
  min-height: 75px;
  align-items: center;
  width: 250px;
  background: #001529;
  transition: all 0.2s;
  border-bottom: 1px solid white;
}

.ant-layout-sider-collapsed .brand-logo {
  width: 80px;
}
.ant-layout-sider-collapsed .brand-logo .brand-icon {
  height: 35px;
  width: auto;
  display: inline-block;
}
.ant-layout-sider-collapsed .brand-logo .brand-icon img {
  width: 45px;
}

.jh-navbar {
  z-index: 1;
  padding: 0;
}
.jh-navbar .container-fluid {
  padding: 0;
}
.jh-navbar .profile-image {
  margin: -10px 0px;
  height: 40px;
  width: 40px;
  border-radius: 50%;
}
.jh-navbar .dropdown-item.active,
.jh-navbar .dropdown-item.active:focus,
.jh-navbar .dropdown-item.active:hover {
  background-color: #353d47;
}
.jh-navbar .dropdown-toggle::after {
  margin-left: 0.15em;
}
.jh-navbar ul.navbar-nav {
  padding: 0.5em 1rem;
}
.jh-navbar ul.navbar-nav .nav-item {
  margin-left: 1.5rem;
}
.jh-navbar a.nav-link {
  font-weight: 400;
}
.jh-navbar a.nav-link > span {
  margin-left: 5px;
}
.jh-navbar .jh-navbar-toggler {
  color: #ccc;
  font-size: 1.5em;
  padding: 10px;
}
.jh-navbar .jh-navbar-toggler:hover {
  color: #fff;
}

.navbar-brand {
  overflow: hidden;
}

.jh-navbar .navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}

.navbar-version {
  font-size: 0.65em;
  color: #bbb;
  padding: 0 0 0 10px;
}

.brand-title {
  font-size: 1.25rem;
  margin-left: 0.25rem;
  color: #fff;
}
.brand-title:hover {
  color: #cccccc;
  text-decoration: none;
}

.loading-bar {
  height: 3px;
  background-color: #009cd8;
  position: absolute;
  top: 0px;
  z-index: 1031;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/shared/layout/header/header.scss"],"names":[],"mappings":"AAGA;;4EAAA;AAGA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,8BAAA;AAFF;;AAME;EACE,WAAA;AAHJ;AAII;EACE,YAAA;EACA,WAAA;EACA,qBAAA;AAFN;AAGM;EACE,WAAA;AADR;;AAOA;EACE,UAAA;EACA,UAAA;AAJF;AAKE;EACE,UAAA;AAHJ;AAKE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAHJ;AAKE;;;EAGE,yBAAA;AAHJ;AAKE;EACE,mBAAA;AAHJ;AAKE;EACE,mBAAA;AAHJ;AAII;EACE,mBAAA;AAFN;AAKE;EACE,gBAAA;AAHJ;AAII;EACE,gBAAA;AAFN;AAKE;EACE,WAAA;EACA,gBAAA;EACA,aAAA;AAHJ;AAII;EACE,WAAA;AAFN;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,gBAAA;EACA,eAAA;AAHF;;AAMA;EACE,iBAAA;EACA,WAlFuB;EAmFvB,mBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,oBAAA;EACA,WA1Fa;AAuFf;AAIE;EACE,cA1FiB;EA2FjB,qBAAA;AAFJ;;AAMA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;AAHF","sourcesContent":["$header-color: #fff;\r\n$header-color-secondary: #bbb;\r\n$header-color-hover: darken($header-color, 20%);\r\n/* ==========================================================================\r\nNavbar styles\r\n========================================================================== */\r\n.brand-logo {\r\n  display: flex;\r\n  justify-content: center;\r\n  min-height: 75px;\r\n  align-items: center;\r\n  width: 250px;\r\n  background: #001529;\r\n  transition: all 0.2s;\r\n  border-bottom: 1px solid white;\r\n}\r\n\r\n.ant-layout-sider-collapsed {\r\n  .brand-logo {\r\n    width: 80px;\r\n    .brand-icon {\r\n      height: 35px;\r\n      width: auto;\r\n      display: inline-block;\r\n      img {\r\n        width: 45px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.jh-navbar {\r\n  z-index: 1;\r\n  padding: 0;\r\n  .container-fluid {\r\n    padding: 0;\r\n  }\r\n  .profile-image {\r\n    margin: -10px 0px;\r\n    height: 40px;\r\n    width: 40px;\r\n    border-radius: 50%;\r\n  }\r\n  .dropdown-item.active,\r\n  .dropdown-item.active:focus,\r\n  .dropdown-item.active:hover {\r\n    background-color: #353d47;\r\n  }\r\n  .dropdown-toggle::after {\r\n    margin-left: 0.15em;\r\n  }\r\n  ul.navbar-nav {\r\n    padding: 0.5em 1rem;\r\n    .nav-item {\r\n      margin-left: 1.5rem;\r\n    }\r\n  }\r\n  a.nav-link {\r\n    font-weight: 400;\r\n    > span {\r\n      margin-left: 5px;\r\n    }\r\n  }\r\n  .jh-navbar-toggler {\r\n    color: #ccc;\r\n    font-size: 1.5em;\r\n    padding: 10px;\r\n    &:hover {\r\n      color: #fff;\r\n    }\r\n  }\r\n}\r\n.navbar-brand {\r\n  overflow: hidden;\r\n}\r\n\r\n.jh-navbar .navbar-nav .nav-link {\r\n  padding-right: 0;\r\n  padding-left: 0;\r\n}\r\n\r\n.navbar-version {\r\n  font-size: 0.65em;\r\n  color: $header-color-secondary;\r\n  padding: 0 0 0 10px;\r\n}\r\n\r\n.brand-title {\r\n  font-size: 1.25rem;\r\n  margin-left: 0.25rem;\r\n  color: $header-color;\r\n  &:hover {\r\n    color: $header-color-hover;\r\n    text-decoration: none;\r\n  }\r\n}\r\n\r\n.loading-bar {\r\n  height: 3px;\r\n  background-color: #009cd8;\r\n  position: absolute;\r\n  top: 0px;\r\n  z-index: 1031;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
